<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-chalkboard-teacher fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{enrollment.customName || enrollment.course.name}}</div>
            <div class="meta mt-1"><i class="fas fa-barcode mr-2 fa-fw"></i>C{{enrollment.id}}</div>
            <div class="meta mt-1"><i class="fas fa-clock mr-2 fa-fw"></i>{{enrollment.units}} Clock Hours<span v-if="enrollment.expires_on && isValidDate(enrollment.expires_on)">, Expires on {{formatDate(enrollment.expires_on, 'MMM Do, YYYY')}}</span></div>
            <div class="meta mt-1"><i class="fas fa-triangle mr-2 fa-fw"></i>
                <span v-if="enrollment.disabled || enrollment.disabletext !== ''" class="has-text-weight-bold has-text-warning">Disabled</span>
                <span v-else-if="enrollment.completed && enrollment.verifyCode && enrollment.verifyCode !== ''" class="has-text-weight-bold has-text-success-dark">Completed & Verified</span>
                <span v-else-if="enrollment.completed && (!enrollment.verifyCode || enrollment.verifyCode === '')" class="has-text-weight-bold has-text-danger">Complete</span>
                <span v-else-if="!enrollment.disabled && enrollment.disabletext === ''" class="has-text-weight-bold has-text-info">In Progress, {{recordedTime}}</span>
            </div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat" v-if="enrollment.totalPaid > 0" style="color: red;"><i class="fas fa-dollar"></i></span>
                <span class="stat" v-if="enrollment.disabled || enrollment.disabletext !== ''"><i class="fas fa-ban"></i></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <div class="data mt-1">
                    <data-row mini title="Course">{{enrollment.course.name}}</data-row>
                    <data-row mini title="Hours">{{enrollment.units}}</data-row>
                    <data-row mini title="Expires">{{formatDate(enrollment.expires_on, 'MMMM Do, YYYY')}}</data-row>
                    <data-row mini title="Active"><i class="far fa-check" v-if="!enrollment.disabled && enrollment.disabletext === ''"></i></data-row>
                    <data-row mini title="Complete"><i class="far fa-check" v-if="enrollment.completed"></i></data-row>
                    <data-row mini title="Cost">{{enrollment.totalPaid}}</data-row>
                    <data-row mini title="Plan">{{enrollment.planID}}</data-row>
                    <data-row mini title="Enroll Date">{{formatDate(enrollment.enrollDate, 'MMMM Do YYYY')}}</data-row>
                    <data-row mini title="Start Date">{{formatDate(enrollment.startedDate, 'MMMM Do YYYY')}}</data-row>
                    <data-row mini title="Completed Date">{{formatDate(enrollment.completedDate, 'MMMM Do YYYY')}}</data-row>
                    <data-row mini title="Verification Date">{{formatDate(enrollment.verifyDate, 'MMMM Do YYYY')}}</data-row>
                    <data-row mini title="Verification">{{enrollment.verifyCode}}</data-row>
                    <data-row mini title="ID">{{enrollment.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'CourseClassicEnrollmentTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            enrollment: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false,
            }
        },
        computed: {
            recordedTime() {
                const formatDuration = (minutes) => {
                    const hours = Math.floor(minutes / 60);
                    const remainingMinutes = minutes % 60;
                    return hours.toString().padStart(2, '0') + ':' + remainingMinutes.toString().padStart(2, '0');
                };

                // Format logtime (in minutes) and units (in hours)
                const logtimeFormatted = formatDuration(this.enrollment.logtime);
                const unitsFormatted = this.enrollment.units.toString().padStart(2, '0') + ':00';

                // Calculate percentage complete
                const totalMinutes = this.enrollment.units * 60;
                const percentageComplete = totalMinutes > 0
                    ? Math.min(Math.round((this.enrollment.logtime / totalMinutes) * 100), 100)
                    : 0;

                return `${logtimeFormatted} of ${unitsFormatted} (${percentageComplete}%)`;
            }
        },
        methods: {
            isValidDate(date) {
                if (!date) return false;
                const m = this.$moment(date);
                return m && m.isValid();
            },
            formatDate(date, format) {
                if (!date) return 'N/A';
                // Use moment.utc for dates from database to avoid timezone issues and deprecation warnings
                const m = this.$moment.utc(date);
                if (!m || !m.isValid()) return 'N/A';
                return m.format(format);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
